import video from "../assets/videos/Tesla Paint Protection Advanced Tint.mp4";
// import video2 from "../assets/videos/advanсed_tint.mp4";
import image from "../assets/images/CommercialWindowTint/Commercial_Residential.png";
import image1 from "../assets/images/Window Tinding/5.png";
import image2 from "../assets/images/Paint Protection/1.png";
import image3 from "../assets/images/Rock_chip_repair.webp";
import ServicesCard from "../components/ServicesCard";
import "../assets/styles/styles.css";
import CustomerReviews from "../components/CustomerReviews";
import { motion } from "framer-motion";
import PartnersSection from "../components/PartnersSection";
import { useEffect, useState } from "react";
import { axiosInstance } from "../config/axios";

const Home = () => {
  const [services, setServices] = useState(null);

  useEffect(() => {
    axiosInstance
      .get("/service_wrapper")
      .then((res) => setServices(res.data))
      .catch((err) => console.log(err));
  }, []);

  // const services = [
  //   {
  //     name: "WINDOW TINTING",
  //     image: image1,
  //     href: "/tinding",
  //   },
  //   {
  //     name: "PAINT PROTECTION",
  //     image: image2,
  //     href: "/protection",
  //   },
  //   {
  //     name: "COMMERCIAL RESIDENTIAL WINDOW TINT",
  //     image: image,
  //     href: "/commercial",
  //   },
  //   {
  //     name: "ROCK CHIP REPAIR",
  //     image: image3,
  //     href: "/repair",
  //   },
  // ];

  return (
    <div className="relative">
      <div className="flex items-center justify-center relative w-[100vw] h-[100vh]">
        <video
          className="absolute z-[-1] w-[100vw] h-[100vh] object-cover"
          autoPlay
          playsInline
          loop
          muted
          style={{ pointerEvents: "none" }}
        >
          <source src={video} type="video/mp4" />
        </video>
        {/* <video
          className="block md:hidden absolute z-[-1] w-[100vw] h-[100vh] object-cover"
          autoPlay
          loop
          muted
        >
          <source src={video2} type="video/mp4" />
        </video> */}
        {/*This is background color for video */}
        <div className="flex absolute z-[1] items-center justify-center w-full h-full bg-black opacity-[0.3]"></div>

        <motion.h2
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{
            damping: 9,
            stiffness: 300,
            restDelta: 2,
            duration: 1,
            type: "spring",
            bounce: 0.6,
            delay: 1.2,
          }}
          className="relative z-[2] text-[35px] sm:text-[70px] md:text-[90px] lg:text-[120px] border-yellow border-[5px] sm:border-[7px] lg:border-[10px] text-white font-extrabold px-[10px] lg:px-[20px] lg:py-[10px] !border-r-0"
        >
          ADVANCED <span className="text-yellow">TINT</span>
        </motion.h2>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 1,
        }}
        className="flex flex-col items-center mt-[50px] sm:mt-[60px] md:mt-[80px] lg:mt-[100px] mx-[10px] md:mx-[25px] lg:mx-[40px] mb-[10px] sm:mb-[20px] md:mb-[25px] lg:mb-[30px] w-full relative"
      >
        <h2 className="uppercase text-white text-[25px] sm:text-[33px] md:text-[48px] border-white border-[4px] md:border-[8px] !border-r-0 !border-t-0 px-[5px] sm:px-[10px] md:px-[15px] font-extrabold">
          Auto <span className="text-yellow">services</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-2 gap-[20px] px-[20px] sm:px-[30px] md:px-[40px] py-[15px] relative">
        {services?.map((item, index) => (
          <ServicesCard
            key={index}
            image={item.image}
            text={item.title}
            isLeft={(index + 1) % 2 == 1}
            navigateTo={item.title}
          />
        ))}
      </div>
      <PartnersSection />
      <CustomerReviews />
    </div>
  );
};

export default Home;
